import { TUseRemainingTimeSaveType } from './useRemainingTime.type';

const TIME_DELAY = 3 * 60 * 1000;

/**
 * @description Вычисление оставшегося времени до обновления пин-кода
 * @param lastRefreshDate
 * @param delay
 */
export const calcRefreshTime = (lastRefreshDate: number | undefined, delay = TIME_DELAY): undefined | string => {
    if (lastRefreshDate) {
        const diff = Date.now() - lastRefreshDate;
        if (diff > delay) {
            return undefined;
        }
        const secondsLeft = Math.floor((delay - diff) / 1000);
        const minutesLeft = Math.floor(secondsLeft / 60);
        const seconds = secondsLeft - minutesLeft * 60;
        return `${minutesLeft ? `${minutesLeft} мин ` : ''}${seconds < 10 ? `0${seconds}` : seconds} сек`;
    }
    return undefined;
};

export const getRefreshDateValue = (save: TUseRemainingTimeSaveType, key: string): number | undefined => {
    let value;
    switch (save) {
        case 'session':
            value = Number(sessionStorage.getItem(key));
            break;
        default:
            value = undefined;
            break;
    }
    return value || undefined;
};

export const setRefreshDateValue = (save: TUseRemainingTimeSaveType, key: string): number => {
    const value = Date.now();
    switch (save) {
        case 'session':
            sessionStorage.setItem(key, String(value));
            break;
        default:
            break;
    }
    return value;
};
